import {
  SIGNUP_INACTIVE,
  SIGNUP_ACTIVE,
  SIGNUP_COMPLETED,
  UPDATE_SIGNUP_STATUS,
  UPDATE_SIGNUP_EMAIL,
} from '../constants';

export function setSignupStatus(status) {
  const action = {
    type: UPDATE_SIGNUP_STATUS,
    payload: status,
  };
  return action;
}
export function setSignupInactive() {
  return (dispatch, getState) => {
    dispatch(setSignupStatus(SIGNUP_INACTIVE));
  };
}

export function setSignupActive() {
  return (dispatch, getState) => {
    dispatch(setSignupStatus(SIGNUP_ACTIVE));
  };
}

export function setSignupCompleted() {
  return (dispatch, getState) => {
    dispatch(setSignupStatus(SIGNUP_COMPLETED));
  };
}

export function setSignupEmail(email) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_SIGNUP_EMAIL, payload: email });
  };
}
